import {
  HalfYearExtensionReason,
  YesOrNoFlug,
} from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";
import { monthMapping } from "../parts";

/**
 * 育休テーブルを作成する
 * @param res
 * @returns infoBodyList
 */
function funInfoBodyList(res: any) {
  const infoBodyList: any[] = [];

  for (let i in res) {
    const data = [
      {
        children: res[i].birthday, //出産日
        align: "center",
      },
      {
        children: res[i].startDate, //育児休業開始日
        align: "center",
      },
      {
        children: res[i].endDate, //育児休業終了日
        align: "center",
      },
      {
        children: TkGetCode(YesOrNoFlug, res[i].papaMamaPlus), //パパママ育休プラス
        align: "center",
      },
      {
        children: TkGetCode(
          HalfYearExtensionReason,
          res[i].halfyearExtensionReason
        ), //半年延長の理由
      },
      {
        children: TkGetCode(YesOrNoFlug, res[i].papaChildcareLeaveFlg), //産後パパ育休
        align: "center",
      },
    ];

    infoBodyList.push(data);
  }

  return infoBodyList;
}

/**
 * 処理履歴を作成する
 * @param res
 * @returns statusBodyList
 */
function funStatusBodyList(res: any) {
  const statusBodyList: any[] = [];
  for (let i in res) {
    let createDate = new Date(res[i].createDate);
    const data = [
      {
        children: res[i].managerName,
      },
      {
        children: res[i].process,
      },
      {
        children:
          createDate.getFullYear() +
          "/" +
          (createDate.getMonth() + 1) +
          "/" +
          createDate.getDate(),
        align: "center",
      },
      {
        children: res[i].processComment,
      },
    ];
    statusBodyList.push(data);
  }

  return statusBodyList;
}

/**
 * 異動履歴を作成する
 * @param res
 * @returns transferHistoryBodyList
 */
function funTransferHistoryList(res: any) {
  const transferHistoryBodyList: any[] = [];
  for (let i in res) {
    const data = {
      leftText: (res[i].joinDate ?? "") + "~" + (res[i].transferDate ?? ""),
      rightText: (res[i].facilityNo ?? "") + ":" + (res[i].facilityName ?? ""),
    };
    transferHistoryBodyList.push(data);
  }

  return transferHistoryBodyList;
}

function convertMonthYears(monthList: any, year: string) {
  let selectedMonths: string[] = [];
  let monthYears: string[] = [];
  let numberYear = Number(year);
  Object.keys(monthMapping).forEach((month: any, index: number) => {
    if (monthList[index] === "1") {
      selectedMonths.push(padNumber(monthMapping[month]));
    }
  });
  selectedMonths.forEach((month: string) => {
    if (Number(month) < 4) {
      monthYears.push(Number(numberYear + 1) + "" + month);
    } else {
      monthYears.push(year + "" + month);
    }
  });
  return monthYears;
}

function padNumber(num: any) {
  return num < 10 ? "0" + num : num.toString();
}

function monthsArrayToUnrecognizedMonthList(monthsArray: any) {
  let monthList: { [key: string]: string } = {};

  let numberToMonth: { [key: string]: string } = {};
  for (let month in monthMapping) {
    numberToMonth[monthMapping[month]] = month;
  }

  Object.values(monthMapping).forEach((monthNumber: any) => {
    const monthName = numberToMonth[monthNumber];
    monthList[monthName] = monthsArray.includes(monthNumber) ? "1" : "0";
  });

  return monthList;
}

export {
  funInfoBodyList,
  funStatusBodyList,
  funTransferHistoryList,
  convertMonthYears,
  monthsArrayToUnrecognizedMonthList,
};
